define(['angular', '../swfobject_modified.min'], function (angular) {
    'use strict';

    function initVideo(step) {
        function delete_cookie(c) {
            var d = new Date();
            d.setTime(d.getTime() - 1);
            document.cookie = c += '=; expires=' + d.toGMTString();
        }
        function get_cookie(c) {
            var d = document.cookie.match('(^|;) ?' + c + '=([^;]*)(;|$)');
            if (d) {
                return unescape(d[2]);
            } else {
                return null;
            }
        }
        function set_cookie(k, p, n, q, o, m, r, l) {
            var s = k + '=' + escape(p);
            if (n) {
                var t = new Date(n, q, o);
                s += '; expires=' + t.toGMTString();
            }
            if (m) {
                s += '; path=' + escape(m);
            }
            if (r) {
                s += '; domain=' + escape(r);
            }
            if (l) {
                s += '; secure';
            }
            document.cookie = s;
        }

        var PlayBackSettings =
            'streamName=step' +
            step +
            'Video&amp;skinName=/bundles/appsite/spokesperson/Clear_Skin&amp;MM_ComponentVersion=1';
        var positioning = 'z-index:2147483647;';
        positioning += 'position: fixed; right: 5px; bottom: 0px;';

        var autoPlay = true;
        var autoPlayOncePerVisit = false;
        var showOncePerVisit = false;
        var showurlList = '';
        var showOnAllPages = true;

        if (autoPlay == false) {
            PlayBackSettings += '&amp;autoPlay=false';
            delete_cookie('autoPlayOncePerVisit');
        } else {
            if (autoPlayOncePerVisit == true) {
                if (get_cookie('autoPlayOncePerVisit') == null) {
                    set_cookie('autoPlayOncePerVisit', 1);
                    PlayBackSettings += '&amp;autoPlay=true';
                } else {
                    PlayBackSettings += '&amp;autoPlay=false';
                }
            } else {
                PlayBackSettings += '&amp;autoPlay=true';
                delete_cookie('autoPlayOncePerVisit');
            }
        }
        if (showOncePerVisit == true) {
            if (get_cookie('showOncePerVisit') == null) {
                set_cookie('showOncePerVisit', 1);
                positioning += 'display:block;';
            } else {
                positioning += 'display:none;';
            }
        } else {
            delete_cookie('showOncePerVisit');
        }
        var posElem = document.getElementById('stepVideo');
        if (typeof posElem.style.cssText != 'undefined') {
            posElem.style.cssText = positioning;
        } else {
            posElem.setAttribute('style', positioning);
        }
        var htmlval =
            '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" align="center" width="260" height="360" id="videoCanvas" style="visibility: inherit;height:360px;">';
        htmlval +=
            '<param name="movie" value="/bundles/appsite/spokesperson/FLVPlayer_Progressive.swf">';
        htmlval += '<param name="scale" value="noscale">';
        htmlval += '<param name="allowfullscreen" value="true">';
        htmlval += '<param name="salign" value="tl">';
        htmlval += '<param name="wmode" value="transparent">';
        htmlval += '<param name="bgcolor" value="#000">';
        htmlval += '<param name="showvolume" value="0">';
        htmlval += '<param name="flashvars" value="' + PlayBackSettings + '">';
        htmlval += '<!--[if !IE]> <-->';
        htmlval +=
            '<object align="center" width="260" height="360" type="application/x-shockwave-flash" data="/bundles/appsite/spokesperson/FLVPlayer_Progressive.swf" style="height:360px;">';
        htmlval += '<param name="scale" value="noscale">';
        htmlval += '<param name="allowfullscreen" value="true">';
        htmlval += '<param name="salign" value="tl">';
        htmlval += '<param name="wmode" value="transparent">';
        htmlval += '<param name="bgcolor" value="#000">';
        htmlval += '<param name="showvolume" value="0">';
        htmlval += '<param name="flashvars" value="' + PlayBackSettings + '">';
        htmlval += '</object>';
        htmlval += '<!--> <![endif]-->';
        htmlval += '</object>';
        document.getElementById('stepVideo').innerHTML = htmlval;
    }

    return angular
        .module('spokespersonDirective', [])
        .directive('spokesperson', function () {
            return {
                restrict: 'E',
                controller: [
                    '$scope',
                    '$attrs',
                    function ($scope, $attrs) {
                        var step = $scope.$eval($attrs.step);

                        initVideo(step);
                    },
                ],
                template: '<div id="stepVideo"></div>',
            };
        });
});
